﻿window.cObjetComSmsEnvoiTrackingVueMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "tracking vue"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau tracking vue"; }
    this.mGetLib1 = function (option) {
        var txt = "Tracking vue"
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }

    this.alignItemGrid = "right"
    this.mGetIcone = function () {
        var $Icone = $("<i class='fas fa-eye' style='position:relative'><i class='fas fa-mobile-screen-button' style='position:absolute;bottom:0;right:0;font-size:50%;color:" + theme.backgroundcolorAccent + ";'></i></i>");
        $Icone.attr("title", "Tracking vue SMS")
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text("Tracking vue SMS") } })
        return $Icone
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        option.bddCtrl = Me.objet.bddRef 
        itemTemplateGrilleClickVue(contentElement, dataTemplate, type, dxGrid, option)
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='" + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.hasScrollPopup = function () { return false }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {
    //    page.mAddPopup(objet.data)
    //}

    this.mGetAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }

}